/**
 * ActivityHeartbeat.js
 *
 * Headless mount point for the presence beacon. Rendered once inside the
 * TeamProvider so it has access to the active world. Renders nothing.
 */

import useActivityHeartbeat from '../hooks/useActivityHeartbeat';

export default function ActivityHeartbeat() {
  useActivityHeartbeat();
  return null;
}
